import type { ChatMessage } from '@/lib/sharedTypes'

interface ChatSystemMessageProps {
  message: ChatMessage
}

function formatSystemEvent(message: ChatMessage): string {
  const event = message.systemEvent
  if (!event) return message.text

  const { action, actorName, targetTitle } = event
  const actor = actorName || '누군가'
  const target = targetTitle ? `"${targetTitle}"` : ''

  const actionMap: Record<string, string> = {
    task_created: `${actor}님이 할일 ${target}을(를) 만들었습니다`,
    task_completed: `${actor}님이 할일 ${target}을(를) 완료했습니다`,
    task_uncompleted: `${actor}님이 할일 ${target}을(를) 미완료로 변경했습니다`,
    task_deleted: `${actor}님이 할일 ${target}을(를) 삭제했습니다`,
    task_assigned: `${actor}님이 할일 ${target}을(를) 배정했습니다`,
    task_updated: `${actor}님이 할일 ${target}을(를) 수정했습니다`,
    member_joined: `${actor}님이 그룹에 참여했습니다`,
    member_left: `${actor}님이 그룹을 나갔습니다`,
    member_role_changed: `${actor}님의 역할이 변경되었습니다`,
    group_updated: `${actor}님이 그룹 정보를 수정했습니다`,
  }

  return actionMap[action] || message.text || `${actor}님이 작업을 수행했습니다`
}

export function ChatSystemMessage({ message }: ChatSystemMessageProps) {
  return (
    <div className="flex justify-center py-1.5">
      <span className="px-3 py-1 rounded-full bg-surface-tertiary text-xs text-caption">
        {formatSystemEvent(message)}
      </span>
    </div>
  )
}
